export { default as NavMenuItem } from './src/navmenu-item.vue';
